import { Timestamp } from "firebase/firestore";
import { z } from "zod";

/**
 * events/{eventId}/track_switch_requests/{attendeeId} (TNG-92).
 *
 * The attendee writes attendeeId, uid, fromTrackId, toTrackId, reason, status
 * OPEN and requestedAt; everything past OPEN is written by the backend
 * (DECIDE_TRACK_SWITCH, ASSIGN_ATTENDEE_TRACKS, DELETE_TRACK and the
 * switch-off sweep). `toTrackName` is the table's name when the request
 * closed, which is all that is left once the table itself is deleted.
 */
export const TRACK_SWITCH_STATUSES = [
  "OPEN",
  "ACCEPTED",
  "DECLINED",
  "CANCELLED",
] as const;
export type TrackSwitchStatus = (typeof TRACK_SWITCH_STATUSES)[number];

export const MAX_REASON_LENGTH = 500;

export const trackSwitchRequestSchema = z.object({
  id: z.string(),
  attendeeId: z.string(),
  uid: z.string(),
  fromTrackId: z.string().nullable().optional(),
  toTrackId: z.string(),
  reason: z.string().optional(),
  status: z.enum(TRACK_SWITCH_STATUSES),
  // A pending server timestamp reads as null in the local echo of the write.
  requestedAt: z.instanceof(Timestamp).nullable(),
  decidedAt: z.instanceof(Timestamp).nullable().optional(),
  decidedBy: z.string().nullable().optional(),
  cancelReason: z.enum(["TRACK_DELETED", "FEATURE_OFF"]).optional(),
  toTrackName: z.string().optional(),
});
export type TrackSwitchRequest = z.infer<typeof trackSwitchRequestSchema>;
